import React from 'react'
import styled from 'styled-components'
import * as FIcons from 'react-icons/fi'

interface InputProps {
    width?: number,
    height?: number,
    iconName?: string,
    align?: string,
    err?: boolean,
    disabled?: boolean,
    placeholderColor?: string,
    bgColor?: string
    textColor?: string,
    fontSize?: number
}

const Field = styled.input<InputProps>`

  width: ${props => props.width ? props.width : 180}px;
  height: ${props => props.height ? props.height : 26}px;
  padding: ${props => props.iconName ? '10px 37px 10px 14px' : '10px'};
  background-color: ${props => props.bgColor ? props.bgColor : '#6C757D'};
  font-family: Cairo, serif;
  color: ${props => props.textColor ? props.textColor : '#fff'};

  border: unset;
  font-size: ${props => props.fontSize ? props.fontSize : 14}px;
  outline: none;
  text-align: ${props => props.align ? props.align : 'right'};
  direction: rtl;
  border: 2px solid ${props => props.err ? 'red' : 'rgba(0,0,0,0.2)'};
  transition: border 0.2s ease;
  border-radius: 8px;

  &::placeholder {
    color: ${props => props.placeholderColor ? props.placeholderColor : '#BBBBBB'};

  }

  &:hover {
    border-color: ${props => props.disabled ? 'red' : '#BBBBBB'}
  }

  &:focus {
    border-color: #BBBBBB;
  }

  &:active {
    border-color: #BBBBBB;
  }
`

interface Props {
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
    value?: string,
    iconName?: string,
    iconSize?: number,
    width?: number,
    height?: number,
    placeholder?: string,
    placeholderColor?: string,
    style?: React.CSSProperties,
    color?: string,
    align?: string,
    err?: boolean,
    disabled?: boolean,
    bgColor?: string
    textColor?: string,
    containerStyle?: React.CSSProperties,
    fontSize?: number,
    type?: string
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  height: auto;
`
const TextField: React.FC<Props> = (props) => {
    let Icon
    if(props.iconName)
        Icon = FIcons[props.iconName as keyof typeof FIcons]
    return (
            <Container style={props.containerStyle}>
                <Field
                        disabled={props.disabled}
                        type={props.type}
                        iconName={props.iconName}
                        placeholder={props.placeholder}
                        align={props.align}
                        onChange={props.handleChange}
                        value={props.value}
                        style={props.style}
                        width={props.width}
                        height={props.height}
                        bgColor={props.bgColor}
                        textColor={props.textColor}
                        fontSize={props.fontSize}
                        err={props.err}
                        placeholderColor={props.placeholderColor}
                />
                {Icon && <Icon color={props.textColor ? props.textColor : '#BBBBBB'} style={{
                    position: 'absolute',
                    fontSize: props.iconSize ? props.iconSize : 24,
                    padding: 2,
                    alignSelf: 'flex-end',
                    right: 5
                    // paddingRight: 10,
                }}/>}
            </Container>
    )
}
export default TextField